const SvgQuantum3 = (props) => (
  <>
    <path
      fill={props.p20}
      d="M.004 48 48.002.002 96.001 48 48.002 95.998zM96.006 47.998 144.005-.001l47.998 47.999-47.998 47.998zM.006 144.002l47.999-47.998 47.998 47.998-47.998 47.999z"
    />
    <path fill={props.p20} d="m95.998 144 47.999-47.998L191.995 144l-47.998 47.998z" />
  </>
);

export default SvgQuantum3;
